import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  Fragment,
} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import '../../index.css';
import ContainerReport from '../../../../../../pages/Builder/Analyze/ContainerReport';
import * as S from './Components/styles';
import iconTag from '../../../../../../assets/images/hash.svg';

import { getBotSessionTags } from '../../../../../../store/actions/reports';
import TagOption from './Components/TagOption';
import TagsGraphicSearchInput from './Components/TagsGraphicSearchInput';

const TagsGraphic = (props) => {
  const {
    match,
    componentData,
    user,
    tags,
    botSessionTags,
    getRefGraphic,
    bot
  } = props;

  const {
    parentFilter,
    draggableId,
    onRemoveClick,
    isEditMode,
  } = componentData;
  const { botid } = match.params;

  const graphicRef = useRef(null);
  const [graphicAlign, setGraphicAlign] = useState('center');
  const [graphicData, setGraphicData] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [timezone, setTimezone] = useState('');

  useEffect(() => {
    getRefGraphic(graphicRef);
  });

  useEffect(() => {
    if (bot && bot.settings && bot.settings.timezone) {
      setTimezone(bot.settings.timezone.fuso);
    }
  },[bot]);

  /**
   * Make API call for search bot sessions tags on component load
   */
  /* useEffect(() => {
    if (user) {
      getReportTags();
    }
  }, [user]); */

  /**
   * Update tags list came from backend, when the report filter change his value
   */
  useEffect(() => {
    if (user && timezone !== 'undefined') {
      getReportTags(timezone);
    }
  }, [parentFilter, user, timezone]);

  /**
   * Update graphic data when the selectedTags list change
   */
  useEffect(() => {
    const newGraphicData = getFilterGraphic();
    setGraphicData(newGraphicData);
  }, [selectedTags, botSessionTags]);

  /**
   * Get filter graphic by tags selected
   * @returns {Array} filtered selected tags for graphic report
   */
  const getFilterGraphic = () => {
    const newList = botSessionTags.filter((tag) =>
      selectedTags.find((selectedTag) => selectedTag.name === tag._id)
    );
    return _.orderBy(newList, 'value', 'desc');
  };

  /**
   * Make the API request for getting the bot session tags
   */
  const getReportTags = (timezone) => {
    const token = user.dashboard_token;
    const { getBotSessionTags } = props;
    getBotSessionTags({ ...parentFilter, botId: botid, token, timezone });
  };

  /**
   * Callback for click on tag for remove from graphic report list
   *
   * @param {object} tag tag object reference that was clicked
   */
  const onClickTagOption = (tag) => {
    const newSelectedTags = [...selectedTags];
    const index = newSelectedTags.indexOf(tag);

    if (index !== -1) {
      newSelectedTags.splice(index, 1);
      setSelectedTags(newSelectedTags);
    }
  };

  const getTagBarWidth = useCallback(
    (value) => {
      const maxFrequency =
        graphicData && graphicData.length ? graphicData[0].value : 0;
      const widthPercent = (100 * value) / maxFrequency;

      return `${widthPercent}%`;
    },
    [graphicData]
  );

  const getTagBarClassName = useCallback(
    (index) => {
      const thirtyPercentPart =
        graphicData && Math.round(graphicData.length / 3);
      const firstInterval = index === 0 || index < thirtyPercentPart;
      const secondInterval =
        index >= thirtyPercentPart && index < thirtyPercentPart * 2;
      const thirtyInterval = index >= thirtyPercentPart * 2;

      if (firstInterval) return 'tag__most-frequently-1';
      if (secondInterval) return 'tag__most-frequently-2';
      if (thirtyInterval) return 'tag__most-frequently-3';
    },
    [graphicData]
  );

  /**
   * Update graphic align class
   */
  const handleChangeGraphicAlign = () => {
    if (graphicAlign === 'center') {
      setGraphicAlign('flex-start');
    }

    if (graphicAlign === 'flex-start') {
      setGraphicAlign('center');
    }
  };

  /**
   * Render list of tags selected for the graphic report
   */
  const renderTagsSelected = () => {
    return selectedTags.map((tag) => {
      return (
        <TagOption
          key={`${tag._id}-component-selected`}
          tag={tag}
          onClickTagOption={onClickTagOption}
        />
      );
    });
  };

  /**
   * Render graphic html elements with tag data
   */
  const renderGraphicElements = () => {
    if (graphicData.length === 0) {
      return false;
    }
    return graphicData.map((tag, index) => {
      const tagBarClass = getTagBarClassName(index);
      const isHighValue =
        tagBarClass === 'tag__most-frequently-1' ||
        tagBarClass == 'tag__most-frequently-2';
      const numberClass = isHighValue
        ? 'tag__frequency-higher'
        : 'tag__frequency';

      return (
        <S.TagBar
          className={tagBarClass}
          key={`tag__${index}`}
          style={{ maxWidth: getTagBarWidth(tag.value) }}
        >
          <span className={numberClass}>{tag.value}</span>
          <div className="tag__name">
            <span className="tag__name-span">{tag._id}</span>
          </div>
        </S.TagBar>
      );
    });
  };

  /**
   * Render graphic html container content
   */
  const renderGraphicContainer = () => {
    if (graphicData.length === 0) {
      return false;
    }
    return (
      <S.Container style={{ marginTop: 10 }}>
        <S.Header>
          <span className="header__name">Freq.</span>
          <span className="header__name">Tag</span>
        </S.Header>
        <S.TagsContainer className={`align__${graphicAlign}`} ref={graphicRef}>
          {renderGraphicElements()}
        </S.TagsContainer>
      </S.Container>
    );
  };

  /**
   * Render report container content for the current report component
   */
  const renderContainerContent = () => {
    if (selectedTags.length === 0) {
      return false;
    }
    return (
      <Fragment>
        <div className="tags-report-selected-tags">{renderTagsSelected()}</div>
        {renderGraphicContainer()}
      </Fragment>
    );
  };

  /**
   * Render html element inline with the container title
   */
  const renderRightTitleContent = () => {
    return (
      <div className="tags-report-title-actions">
        <TagsGraphicSearchInput
          botId={botid}
          parentFilter={parentFilter}
          selectedTags={selectedTags}
          setSelectedTags={setSelectedTags}
        />
        <S.AlignmentButton
          onClick={handleChangeGraphicAlign}
          className={`align__${graphicAlign}`}
        >
          <span className="first-line" />
          <span className="second-line" />
          <span className="third-line" />
        </S.AlignmentButton>
      </div>
    );
  };

  return (
    <ContainerReport
      type="graphic"
      title="Tags"
      icon={iconTag}
      containerContent={renderContainerContent()}
      renderRightTitleContent={renderRightTitleContent()}
      draggableId={draggableId}
      onRemoveClick={onRemoveClick}
      isEditMode={isEditMode}
      containerCustomClass="container-graphic-funnel"
      bodyInfoCustomClass="body-info-relatorio-tags"
      headerCustomClass="header-grafico-tags"
    />
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    tags: state.tags.tagsState.tags,
    botSessionTags: state.reports.botSessionTags,
    bot: state.bots.bot
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getBotSessionTags }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TagsGraphic)
);
